import { Auth } from 'aws-amplify';
import { emptySplitApi } from 'redux/helpers/slice.helpers';
import { claimSavedFilters, clearSessionStorage } from 'helpers/storage';
import { filtersSlice } from 'redux/slices/filters.slice';
import { TSignInAmplifyUI, TSignInChallengeUI } from 'data/types/Auth.types';
import { TAmplifyError, TAmplifyUser } from 'data/types/Amplify.types';

export const authApi = emptySplitApi('authApi').injectEndpoints({
  endpoints: build => ({
    signIn: build.mutation<TAmplifyUser | TSignInChallengeUI, TSignInAmplifyUI>(
      {
        // @ts-expect-error -- the error branch returns Amplify's error shape, which RTK's
        // FetchBaseQueryError type does not describe.
        async queryFn(arg, api) {
          try {
            const amplifyUser = await Auth.signIn(arg.email, arg.password);
            if (amplifyUser.challengeName === 'NEW_PASSWORD_REQUIRED') {
              return { data: { challengeName: amplifyUser.challengeName } };
            }
            localStorage.setItem('user', JSON.stringify(amplifyUser));
            if (claimSavedFilters(amplifyUser.username)) {
              api.dispatch(filtersSlice.actions.reloadSavedFilters());
            }
            return { data: amplifyUser.attributes };
          } catch (e) {
            const error = e as TAmplifyError;
            return {
              error: {
                data: {
                  name: error.name,
                  code: error.code,
                  message: error.message,
                  username: arg.email,
                },
                status: error.code,
              },
            };
          }
        },
      },
    ),
    signOut: build.mutation<null, void>({
      async queryFn() {
        // Amplify signs out the user it finds in storage, so the session is cleared afterwards:
        // clearing first left it no user, and nothing was revoked. A local sign-out revokes this
        // session's refresh token only; the admin's other devices and tabs stay signed in.
        try {
          await Auth.signOut();
        } catch (e) {
          console.warn('Cognito signOut failed:', e);
        }
        clearSessionStorage();
        return { data: null };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useSignInMutation, useSignOutMutation } = authApi;
